export const initialState = {
    headerColor: "",
    logoUrl: "",
    backgroundUrl: "",
    termsAndConditions: "",
    languageIsoCode2: "",
    languageIsoCode2Default: "",
    languages: []
};
  